export default "__VITE_ASSET__ctN0ijmB__"